import { Comment as AntDComment } from '@ant-design/compatible';
import { Space, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { channelType, Comment } from '../../../model/types';
import {
    getFormattedDateWithHourWithDayjs,
    getMaskedEmailForUI,
    getUserCredentialsToShow
} from '../../../utils/helpers';
import ProfilePicture from '../../ProfilePicture';
import { formatDate } from '../../TimeDisplay';
import ConversationContent from './ConversationContent';

interface ConversationProps {
    lastItem?: boolean;
    conversation: Comment;
    showAvatar?: boolean;
    showAttachments?: boolean;
    to?: string;
}

export default function Conversation(props: ConversationProps) {
    const {
        token: { borderRadius, margin, paddingSM }
    } = theme.useToken();
    const { t } = useTranslation('tickets');

    const { conversation, showAvatar = true, lastItem = false } = props;
    if (!conversation) return null;

    const { channel, createdAt, creator } = conversation;

    return (
        <AntDComment
            author={getUserCredentialsToShow(creator, false)}
            {...(showAvatar && {
                avatar: <ProfilePicture src={creator?.profilePicture} alt={getMaskedEmailForUI(creator?.email)} />
            })}
            content={<ConversationContent {...props} />}
            datetime={
                <Space size="small">
                    <Tooltip title={getFormattedDateWithHourWithDayjs(createdAt)}>
                        <span>{formatDate(createdAt, { fromNow: true })}</span>
                    </Tooltip>
                    <span>
                        {t('subjectHelperText', {
                            createdAt: null,
                            ticketChannel: t(`channelNames.${channel as channelType}`)
                        })}
                    </span>
                </Space>
            }
            style={{
                borderRadius,
                paddingBottom: 0,
                paddingLeft: paddingSM,
                paddingRight: paddingSM,
                paddingTop: 0,
                ...(!lastItem ? { marginBottom: margin / 2 } : {})
            }}
        />
    );
}

export { type ConversationProps };
